/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {GumMatrixDO | null}
 */

import { getRawDataFromGumMatrixRaw } from "../convert/rawConver";

export const getGumMatrixDOFromFilePath = async (filePath, fileUrl) => {
  const regex = /.*_STAGE_(\d+).*__(LOWER|UPPER)__GUM.raw$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    const gumMatrix = await getRawDataFromGumMatrixRaw(fileUrl);

    return {
      stageNumber,
      toothGumType,
      gumMatrix,
    };
  }
  return null;
};
